var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:_vm.classes,attrs:{"disabled":_vm.value === _vm.id},on:{"click":function($event){return _vm.$emit('input', _vm.id)}}},[_c('span'),_c('p',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }